
export const AUTH_INITIATE_SIGNUP = 'AUTH_INITIATE_SIGNUP';
export const AUTH_SIGNUP_START = 'AUTH_SIGNUP_START';
export const AUTH_SIGNUP_SUCCESS = 'AUTH_SIGNUP_SUCCESS';
export const AUTH_SIGNUP_FAIL = 'AUTH_SIGNUP_FAIL';
export const AUTH_SIGNUP_RESET = 'AUTH_SIGNUP_RESET';